import * as React from 'react';
import { Skeleton, Box } from 'wix-style-react';

const WidgetSkeleton = () => (
  <Box display="block" height="100%" width="100%" padding="30px 30px 25px">
    <Skeleton
      content={[
        {
          size: 'small',
          type: 'line',
        },
        {
          size: 'large',
          type: 'line',
        },
        {
          size: 'large',
          type: 'line',
        },
      ]}
    />
  </Box>
);

export interface ILazyWidgetCardProps {
  onLoaded(): void;
}

export interface IProps {
  children: React.ReactElement<ILazyWidgetCardProps>;
}

export interface IState {
  isWidgetLoaded: boolean;
}

export class LazyWidgetCard extends React.PureComponent<IProps, IState> {
  readonly state = { isWidgetLoaded: false };

  onLoaded = () => {
    this.setState({ isWidgetLoaded: true });

    const {
      children: {
        props: { onLoaded },
      },
    } = this.props;
    if (onLoaded) {
      onLoaded();
    }
  };

  readonly childrenComponent = React.cloneElement(this.props.children, {
    onLoaded: this.onLoaded,
  });

  renderChildren() {
    const { isWidgetLoaded } = this.state;

    return (
      <>
        <Box
          width="100%"
          height="100%"
          borderRadius="8px"
          display={isWidgetLoaded ? 'block' : 'none'}
        >
          {this.childrenComponent}
        </Box>
        {!isWidgetLoaded && <WidgetSkeleton />}
      </>
    );
  }

  render() {
    return (
      <Box
        backgroundColor="white"
        display="flex"
        align="center"
        borderRadius="8px"
        height="100%"
        verticalAlign="middle"
      >
        {this.renderChildren()}
      </Box>
    );
  }
}
